module.exports = __webpack_public_path__ + "static/media/toool.0a95fe02.png";